export const formatTime = (sec: number) => {
	const roundedSec = Math.floor(sec);
	const hours = Math.floor(roundedSec / 3600);
	const minutes = Math.floor((roundedSec / 60) - (hours * 60));
	const seconds = Math.round(roundedSec % 60);

	if (hours === 0) return `${String(minutes)}:${String(seconds).padStart(2, '0')}`;
	return `${String(hours)}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};
